import { useAutoAnimate } from "@formkit/auto-animate/react"
import React from "react"

interface CheckboxProps {
	props?: any
	className?: string | null
	label?: any
	errMsg?: string
	hasError?: boolean
	children?: React.ReactNode
}

const ElemCheckboxMafo: React.FC<CheckboxProps> = ({ className, label, errMsg, hasError, children }) => {
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	return (
		<label className={"relative block cursor-pointer mt-2 mb-2" + (className || "")}>
			<div className="flex font-AmsiRegular">
				{children}
				<span className="flex h-[32px] w-[32px] flex-shrink-0 peer-checked:hidden">
					<img src={process.env.PUBLIC_URL + "/images/checkbox.svg"} alt="check" className="w-[30px]" />
				</span>
				<span className="block flex hidden h-[32px] w-[32px] flex-shrink-0 peer-checked:flex">
					<img src={process.env.PUBLIC_URL + "/images/checkbox-checked.svg"} alt="check" className="w-[30px]" />
				</span>
				<div>
					<div className="pl-2 text-[18px] text-blue lg:text-[20px] font-AmsiRegular max-w-[80vw]">{label}</div>
					<div ref={animationRef}>{hasError && <div className="formErrorMsg js-formerror pl-2 pt-2 font-bold text-red">{errMsg}</div>}</div>
				</div>
			</div>
		</label>
	)
}

export default ElemCheckboxMafo
